exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".-WlTYEzk67OPRcety-ns6 .ms-Dialog-subText{font-size:14px;font-weight:400}", ""]);

// exports
exports.locals = {
	"dialogContainer": "-WlTYEzk67OPRcety-ns6"
};